import React, { useEffect, useRef } from "react";
import CheckboxQuestionUpdated from "../CheckboxQuestionUpdated";

const NONE_OF_THESE = "noneOfThese";

// Asks several Yes/No fields as one "tick all that apply" question. Each option's
// name is a field: ticked is true, unticked is false once anything is ticked, and
// all are unset until the client ticks something, so "None of these" has to be
// ticked to answer No to them all.
const AnyOfTheseQuestion = ({ options, fields, onChange, invalid }) => {
  const ref = useRef(null);
  // The list is long, so on a phone its error can be above the screen when Continue is tapped
  useEffect(() => {
    if (invalid) ref.current?.scrollIntoView?.({ block: "start" });
  }, [invalid]);

  const names = options.map((option) => option.name);
  const answers = (value) => Object.fromEntries(names.map((name) => [name, value]));

  const selected = new Map([
    ...names.map((name) => [name, !!fields[name]]),
    [NONE_OF_THESE, names.every((name) => fields[name] === false)],
  ]);

  const handleChange = (event) => {
    const { name, checked } = event.target;
    if (name === NONE_OF_THESE) {
      onChange(answers(checked ? false : null));
      return;
    }
    const next = Object.fromEntries(names.map((n) => [n, n === name ? checked : !!fields[n]]));
    onChange(Object.values(next).some(Boolean) ? next : answers(null));
  };

  return (
    <div ref={ref}>
      <CheckboxQuestionUpdated
        question="Do any of these apply?"
        hint="Tick all that apply"
        options={[...options, { name: NONE_OF_THESE, title: "None of these", strong: true }]}
        selected={selected}
        onChange={handleChange}
        validationError={invalid ? "Tick the ones that apply, or ‘None of these’" : null}
      />
    </div>
  );
};

export default AnyOfTheseQuestion;
